import _ from 'lodash';
import assert from 'assert';

/**
 * This function defines a new layout:
 * * Registers a wrapper directive for the layout
 * * Registers directives for any partials defined for the layout
 *
 * @param {string}      layoutName  Layout name string. Layout will be automatically prefixed with 'gw-'
 * @param {string}      template    Layout template string.
 * @param {function}    definition  Definition function. 'createPartial' method is passed in to define partials.
 *
 * @returns {String}
 */
export default (function (layoutName, template, definition) {
    var layoutDirectiveName = 'gw' + layoutName; // gwSomeLayout
    var moduleName = 'edge.platform.layout.' + layoutName;

    var getPartialDirectiveName = function getPartialDirectiveName(partial) {
        return _.kebabCase('' + layoutDirectiveName + partial);
    };

    var knownPartials = function () {
        // lElement is created in a closure so that it gets garbage-collected after known partials are selected
        var lElement = document.createElement('div');
        lElement.innerHTML = template;

        return Array.from(lElement.querySelectorAll('[gw-partial]')).map(function (el) {
            return el.attributes['gw-partial'].value;
        });
    }();

    // Create a separate module for the layout and the outer directive
    var module = angular.module(moduleName, []).directive(layoutDirectiveName, [function () {
        return {
            restrict: 'E',

            // Make sure this doesn't creates a new state —
            // current state should be used so that layouts are transparent
            // for any inner directives with two-way binding
            scope: false,
            compile: function compile(tElement) {
                var partials = {};
                knownPartials.forEach(function (partial) {
                    // .html() call later will clean up angular info stored under .data() unless element is detached first
                    partials[partial] = tElement.find(getPartialDirectiveName(partial)).detach();
                });

                tElement.html(template);
                knownPartials.forEach(function (partial) {
                    var partialContainer = angular.element(tElement[0].querySelector('[gw-partial="' + partial + '"]'));
                    partialContainer.append(partials[partial]);
                });

                return function () {};
            }
        };
    }]);

    var createPartial = function createPartial(partialName, partialTemplate, controller) {
        assert(knownPartials.includes(partialName), 'Partial ' + partialName + ' does not exists in layout template');

        // Register a partial directive to capture types of content inside the layout
        module.directive('' + layoutDirectiveName + partialName, function () {
            return { // gwSomeLayoutSomePartial
                restrict: 'E',
                transclude: true,
                replace: true,
                scope: false,
                controller: controller || [function () {}],
                // If we use $ctrl here, it will overwrite any parent controller that this directive is used in, resulting in unforseen behaviour
                controllerAs: 'layoutController',
                template: partialTemplate || '<div gw-partial-target></div>',
                link: function link($scope, $element, attrs, ctrl, transclude) {
                    transclude($scope, function (transcludedContent) {
                        var targetSelector = '[gw-partial-target]';
                        if ($element.is(targetSelector)) {
                            $element.append(transcludedContent);
                        } else {
                            $element.children(targetSelector).append(transcludedContent);
                        }
                    });
                }
            };
        });
    };

    definition(createPartial);

    return moduleName;
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/layouts/LayoutFactory.js
// module id = 46
// module chunks = 0